var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-view',{attrs:{"activeTab":_vm.activeTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }